import styled from '@emotion/styled'
import CurrencyInputField from 'react-currency-input-field'

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`

export const FlexColumnCenter = styled(FlexColumn)`
  align-items: center;
`

export const FormContainer = styled.div`
  margin-top: 30px;
  padding: 0 10px 30px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const InputGroup = styled(FlexColumn)`
  align-items: center;
  width: 100%;
  max-width: 360px;

  & + & {
    margin-top: 30px;
  }
`

export const InputLabel = styled.label`
  display: flex;
  align-items: flex-end;
  height: 30px;
  font-weight: 600;
  margin-bottom: 10px;
  text-align: center;

  & > sup {
    font-weight: normal;
    align-self: center;
  }
`

const textFieldStyle = `
  border-radius: 9999px;
  border: 1px solid black;
  height: 42px;
  width: 100%;
  box-sizing: border-box;
  padding-left: 20px;
  font-size: 1rem;
  color: hsl(0, 0%, 20%);
  outline: none;
`
export const TextField = styled.input`
  ${textFieldStyle}
`
export const SuffixedTextField = styled(CurrencyInputField)`
  ${textFieldStyle}
`

export const PrimaryButton = styled.button<{ color: string }>`
  appearence: none;
  height: 42px;
  width: 100%;
  border: none;
  border-radius: 9999px;
  background-color: ${props => props.color};
  color: #fff;
  font-weight: 600;
  margin: 0 auto;
  max-width: 300px;

  &:disabled {
    opacity: 0.5;
  }
`

export const TextLink = styled.a`
  text-decoration: underline;
  color: black;
`
